import(/* webpackMode: "eager", webpackExports: ["PandaIcons"] */ "/home/runner/work/pandahub-website-nextjs/pandahub-website-nextjs/components/icons/pandaIcons/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/pandahub-website-nextjs/pandahub-website-nextjs/node_modules/next/dist/client/image-component.js");
